import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 14 22",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M12.719 6.875H7.76l1.83-5.577A1.035 1.035 0 0 0 8.595 0H2.406c-.515 0-.954.382-1.022.894L.009 11.206c-.082.619.4 1.169 1.022 1.169h5.1l-1.98 8.357a1.03 1.03 0 0 0 1.895.752l7.562-13.062a1.03 1.03 0 0 0-.89-1.547Z" }, null, -1)
  ]))]))
}
export default { render: render }